"use client";

import React from "react";

import { ImagesListItemProps, LinkListProps } from "../types";
import FilterImageLink from "../FilterImageLink";

export default function Images({ heading = "", subjectMap }: LinkListProps) {
  if (subjectMap === undefined || subjectMap.length === 0) {
    return null;
  }

  const rows = [];
  for (let i = 0; i < subjectMap.length; i += 5) {
    rows.push(subjectMap.slice(i, i + 5));
  }

  return (
    <div className="fullwidth pb-8 mb-8 pl-0">
      {heading && (
        <h2 className="mt-0 mb-5 md:mb-6 text-3xl md:text-4xl">{heading}</h2>
      )}

      <div className="flex overflow-auto whitespace-nowrap gap-3 grid grid-cols-1">
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className="flex gap-3">
            {row.map((subject, index) => (
              <FilterImageLink
                key={rowIndex * 5 + index}
                {...subject}
                index={rowIndex * 5 + index}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
